import { render, staticRenderFns } from "./DropFile.vue?vue&type=template&id=18db914c&scoped=true"
import script from "./DropFile.vue?vue&type=script&lang=js"
export * from "./DropFile.vue?vue&type=script&lang=js"
import style0 from "./DropFile.vue?vue&type=style&index=0&id=18db914c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18db914c",
  null
  
)

export default component.exports